export const JOBPOSTS = {};

export const LACKOFJOBPOSTS = {
  recruiter: {
    heading: 'You don’t have any jobs yet. Start building your list.',
    button: 'View all jobs',
  },
  employer: {
    heading: 'You don’t have a job posting yet. Click below to create one.',
    button: 'Create a job posting',
  },
};
